import {
ACCOUNT_VERIFICATION_REQUEST,
ACCOUNT_VERIFICATION_SUCCESS,
ACCOUNT_VERIFICATION_FAILURE
} from "../SelfSignUp/constants";

export const verifyEmailRequest = (payload) => {
  return ({
  type: ACCOUNT_VERIFICATION_REQUEST,
  payload,
})};

export const verifyEmailSuccess = (payload) => ({
  type: ACCOUNT_VERIFICATION_SUCCESS,
  payload,
});

export const verifyEmailFailure = (payload) => ({
  type: ACCOUNT_VERIFICATION_FAILURE,
  payload,
});





// WEBPACK FOOTER //
// ./src/containers/ConfirmEmailPage/actions.js